// extracted by css-extract-rspack-plugin
export default {"header":"header-VDaCwa","back":"back-drJbgI"};